(function () {
  function getRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function getBlocks() {
    return document.querySelectorAll('[data-lottery-ticket-progress]');
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && format) {
      return window.Shopify.formatMoney(cents, format);
    }

    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function applyTemplate(template, replacements) {
    var output = template || '';

    Object.keys(replacements).forEach(function (key) {
      output = output.split('[' + key + ']').join(replacements[key]);
    });

    return output;
  }

  function updateBlocks(totalCents) {
    var blocks = getBlocks();

    if (!blocks.length || typeof totalCents !== 'number') {
      return;
    }

    blocks.forEach(function (block) {
      var threshold = parseInt(block.getAttribute('data-threshold'), 10);
      var moneyFormat = block.getAttribute('data-money-format') || '';
      var countOneTemplate = block.getAttribute('data-count-one') || 'Je hebt [count] lootje';
      var countOtherTemplate = block.getAttribute('data-count-other') || 'Je hebt [count] lootjes';
      var remainingTemplate = block.getAttribute('data-remaining') || 'Geef nog [amount] uit voor nog 1 lootje';
      var countEl = block.querySelector('[data-lottery-ticket-count]');
      var remainingEl = block.querySelector('[data-lottery-ticket-remaining]');
      var fillEl = block.querySelector('[data-lottery-ticket-fill]');

      if (!threshold || threshold < 1 || !countEl || !remainingEl || !fillEl) {
        return;
      }

      var thresholdCents = threshold * 100;
      var tickets = Math.floor(totalCents / thresholdCents);
      var remainder = totalCents % thresholdCents;
      var remaining = thresholdCents;
      var progress = 0;

      if (totalCents === 0) {
        remaining = thresholdCents;
        progress = 0;
      } else if (remainder === 0) {
        remaining = thresholdCents;
        progress = 0;
      } else {
        remaining = thresholdCents - remainder;
        progress = (remainder / thresholdCents) * 100;
      }

      countEl.textContent = applyTemplate(
        tickets === 1 ? countOneTemplate : countOtherTemplate,
        { count: String(tickets) }
      );

      remainingEl.textContent = applyTemplate(
        remainingTemplate,
        { amount: formatMoney(remaining, moneyFormat) }
      );

      fillEl.style.width = progress + '%';
    });
  }

  async function fetchCart() {
    var response = await fetch(getRoot() + 'cart.js', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('CART_FETCH_FAILED');
    }

    return response.json();
  }

  async function refreshLotteryTicketProgress() {
    try {
      var cart = await fetchCart();

      if (cart && typeof cart.total_price === 'number') {
        updateBlocks(cart.total_price);
      }
    } catch (error) {}
  }

  function debounce(fn, delay) {
    var timeout;

    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(fn, delay);
    };
  }

  function initObservers() {
    var debouncedRefresh = debounce(refreshLotteryTicketProgress, 150);
    var subtotalNode = document.querySelector('[data-subtotal]');
    var productsNode = document.querySelector('[data-products]');

    if (subtotalNode) {
      new MutationObserver(debouncedRefresh).observe(subtotalNode, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    if (productsNode) {
      new MutationObserver(debouncedRefresh).observe(productsNode, {
        childList: true,
        subtree: true
      });
    }

    document.addEventListener('cart:updated', debouncedRefresh);
    document.addEventListener('cart:build', debouncedRefresh);
    document.addEventListener('ajaxProduct:added', debouncedRefresh);
  }

  function initLotteryTicketProgress() {
    if (window.__lotteryTicketProgressInitialized) {
      return;
    }

    window.__lotteryTicketProgressInitialized = true;

    refreshLotteryTicketProgress();
    setTimeout(refreshLotteryTicketProgress, 250);
    setTimeout(refreshLotteryTicketProgress, 1000);
    setTimeout(refreshLotteryTicketProgress, 2000);

    initObservers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLotteryTicketProgress);
  } else {
    initLotteryTicketProgress();
  }

  window.addEventListener('load', initLotteryTicketProgress);
})();